package com.daytimegaming.ourdailyfinances.di

import com.daytimegaming.ourdailyfinances.presentation.MainViewModel
import com.daytimegaming.ourdailyfinances.presentation.account.AccountDetailViewModel
import com.daytimegaming.ourdailyfinances.presentation.account.AddRealEstateHoldingViewModel
import com.daytimegaming.ourdailyfinances.presentation.account.SecurityHoldingDetailViewModel
import com.daytimegaming.ourdailyfinances.presentation.account.TransactionDetailViewModel
import com.daytimegaming.ourdailyfinances.presentation.account.UpdateRealEstateHoldingViewModel
import com.daytimegaming.ourdailyfinances.presentation.account.ViewRealEstateHoldingViewModel
import com.daytimegaming.ourdailyfinances.presentation.auth.LoginViewModel
import com.daytimegaming.ourdailyfinances.presentation.auth.RegisterViewModel
import com.daytimegaming.ourdailyfinances.presentation.auth.UpdateUserInfoViewModel
import com.daytimegaming.ourdailyfinances.presentation.budget.CreateBudgetViewModel
import com.daytimegaming.ourdailyfinances.presentation.budget.UpdateBudgetViewModel
import com.daytimegaming.ourdailyfinances.presentation.budget.ViewBudgetViewModel
import com.daytimegaming.ourdailyfinances.presentation.dashboard.ConfigureDashboardViewModel
import com.daytimegaming.ourdailyfinances.presentation.dashboard.CreateDashboardViewModel
import com.daytimegaming.ourdailyfinances.presentation.dashboard.DashboardDetailViewModel
import com.daytimegaming.ourdailyfinances.presentation.dashboard.DashboardTransactionsViewModel
import com.daytimegaming.ourdailyfinances.presentation.dashboard.JoinDashboardViewModel
import com.daytimegaming.ourdailyfinances.presentation.home.AccountsViewModel
import com.daytimegaming.ourdailyfinances.presentation.home.CategorySpendingViewModel
import com.daytimegaming.ourdailyfinances.presentation.home.DashboardsViewModel
import com.daytimegaming.ourdailyfinances.presentation.home.ManageSubscriptionViewModel
import com.daytimegaming.ourdailyfinances.presentation.home.RecentSpendingViewModel
import com.daytimegaming.ourdailyfinances.presentation.home.IncomeVsExpensesSummaryViewModel
import com.daytimegaming.ourdailyfinances.presentation.home.MonthlyBreakdownViewModel
import com.daytimegaming.ourdailyfinances.presentation.home.RecurringTransactionDetailViewModel
import com.daytimegaming.ourdailyfinances.presentation.home.RecurringTransactionsViewModel
import com.daytimegaming.ourdailyfinances.presentation.home.SettingsViewModel
import com.daytimegaming.ourdailyfinances.presentation.home.SpendingRange
import com.daytimegaming.ourdailyfinances.presentation.home.TransactionsViewModel
import com.daytimegaming.ourdailyfinances.presentation.manageaccounts.ManageAccountsViewModel
import org.koin.core.module.Module
import org.koin.core.module.dsl.viewModel
import org.koin.dsl.module

actual fun viewModelModule(): Module = module {
    viewModel { MainViewModel(get(), get(), get()) }
    viewModel { LoginViewModel(get(), get()) }
    viewModel { RegisterViewModel(get(), get()) }
    viewModel { UpdateUserInfoViewModel(get()) }
    viewModel { DashboardsViewModel(get(), get(), get(), get(), get(), get(), get(), get(), get(), get(), get()) }
    viewModel { AccountsViewModel(get(), get(), get(), get(), get(), get(), get(), get(), get(), get()) }
    viewModel { TransactionsViewModel(get(), get(), get()) }
    viewModel { RecentSpendingViewModel(get(), get(), get(), get()) }
    viewModel { IncomeVsExpensesSummaryViewModel(get(), get(), get()) }
    viewModel { SettingsViewModel(get(), get(), get(), get()) }
    viewModel { ManageSubscriptionViewModel(get(), get()) }
    viewModel { ManageAccountsViewModel(get(), get(), get(), get(), get(), get()) }
    viewModel { AddRealEstateHoldingViewModel(get(), get(), get()) }
    viewModel { CreateDashboardViewModel(get(), get()) }
    viewModel { JoinDashboardViewModel(get(), get()) }
    viewModel { RecurringTransactionsViewModel(get(), get(), get()) }
    viewModel { CreateBudgetViewModel(get(), get()) }
    viewModel { params -> DashboardDetailViewModel(params.get(), get(), get(), get(), get(), get()) }
    viewModel { params -> ConfigureDashboardViewModel(params.get(), get(), get(), get(), get()) }
    viewModel { params ->
        val accountId = params.get<String>(0)
        val dashboardId = if (params.values.size > 1) params.get<String>(1) else null
        AccountDetailViewModel(accountId, dashboardId, get(), get(), get(), get(), get(), get(), get())
    }
    viewModel { params ->
        val accountId = params.get<String>(0)
        val securityId = params.get<String>(1)
        val dashboardId = if (params.values.size > 2) params.get<String>(2) else null
        SecurityHoldingDetailViewModel(accountId, securityId, dashboardId, get(), get(), get())
    }
    viewModel { params -> DashboardTransactionsViewModel(params.get(), get()) }
    viewModel { params ->
        val categoryName = params.get<String>(0)
        val range = params.get<SpendingRange>(1)
        CategorySpendingViewModel(categoryName, range, get(), get(), get())
    }
    viewModel { params ->
        val yearMonth = params.get<String>(0)
        MonthlyBreakdownViewModel(yearMonth, get(), get(), get())
    }
    viewModel { params ->
        val transactionId = params.get<String>(0)
        val dashboardId = if (params.values.size > 1) params.get<String>(1) else null
        TransactionDetailViewModel(transactionId, dashboardId, get(), get())
    }
    viewModel { params ->
        val streamId = params.get<String>(0)
        RecurringTransactionDetailViewModel(streamId, get(), get())
    }
    viewModel { params ->
        val budgetId = params.get<String>(0)
        ViewBudgetViewModel(budgetId, get(), get(), get(), get())
    }
    viewModel { params ->
        val budgetId = params.get<String>(0)
        UpdateBudgetViewModel(budgetId, get(), get())
    }
    viewModel { params ->
        val realEstateHoldingId = params.get<String>(0)
        ViewRealEstateHoldingViewModel(realEstateHoldingId, get(), get())
    }
    viewModel { params ->
        val realEstateHoldingId = params.get<String>(0)
        UpdateRealEstateHoldingViewModel(realEstateHoldingId, get(), get())
    }
}
